import api from "./api";

export async function listTenantDocuments(params = {}) {
  const res = await api.get("/tenant/documents", { params });
  return res.data;
}

export async function getTenantDocumentById(id) {
  const res = await api.get(`/tenant/documents/${id}`);
  return res.data;
}

export async function createTenantDocument(payload) {
  const res = await api.post("/tenant/documents", payload);
  return res.data;
}

export async function updateTenantDocument(id, payload) {
  const res = await api.put(`/tenant/documents/${id}`, payload);
  return res.data;
}

export async function archiveTenantDocument(id) {
  const res = await api.delete(`/tenant/documents/${id}`);
  return res.data;
}
